import React from 'react'
import { CalendarRange } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import store from '../../../../../../state/store'
import WeeklyTimeslots from '../../../../../availability/show'

const DAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

const NOTICE_HOURS_OPTIONS = [
  { value: 2, label: '2 hours' },
  { value: 4, label: '4 hours' },
  { value: 8, label: '8 hours' },
  { value: 12, label: '12 hours' },
  { value: 24, label: '24 hours' },
]

class MeetingAvailability extends React.Component {
  constructor(props) {
    super(props)

    const meeting = this.props.meeting_availability || {}

    this.state = {
      enabled: meeting.enabled || false,
      minimum_notice_hours: meeting.minimum_notice_hours || 24,
    }
  }

  windowsToTimes(windows) {
    const times = []
    for (const window of (windows || [])) {
      for (const day of window.days) {
        times.push({
          day_of_week: DAY_NAMES[day - 1],
          start_time: window.start_time,
          end_time: window.end_time,
        })
      }
    }
    return times
  }

  timesToWindows(times) {
    const windowMap = {}
    for (const time of times) {
      const key = `${time.start_time}-${time.end_time}`
      const dayIndex = DAY_NAMES.indexOf(time.day_of_week) + 1
      if (!windowMap[key]) {
        windowMap[key] = { days: [], start_time: time.start_time, end_time: time.end_time }
      }
      windowMap[key].days.push(dayIndex)
    }
    return Object.values(windowMap).map(w => ({ ...w, days: w.days.sort() }))
  }

  onEnabledToggle = () => {
    this.setState({ enabled: !this.state.enabled })
  }

  onNoticeHoursChange = (value) => {
    this.setState({ minimum_notice_hours: parseInt(value, 10) })
  }

  onSaveTimes = (timeslots) => {
    const windows = this.timesToWindows(timeslots)

    store.emit('tutoring_job:tutor_results:meeting_availability:update', {
      tutor_id: this.props.tutor_result.tutor.id,
      tutoring_job_id: this.props.tutor_result.tutoring_job_id,
      windows: windows,
      meetings_enabled: this.state.enabled,
      meeting_minimum_notice_hours: this.state.minimum_notice_hours,
    })
  }

  onSaveSettings = () => {
    const meeting = this.props.meeting_availability || {}
    const windows = meeting.windows || []

    store.emit('tutoring_job:tutor_results:meeting_availability:update', {
      tutor_id: this.props.tutor_result.tutor.id,
      tutoring_job_id: this.props.tutor_result.tutoring_job_id,
      windows: windows,
      meetings_enabled: this.state.enabled,
      meeting_minimum_notice_hours: this.state.minimum_notice_hours,
    })
  }

  render() {
    const meeting = this.props.meeting_availability || {}
    const times = this.windowsToTimes(meeting.windows)

    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <CalendarRange className="size-4"/>
            Meeting Availability
          </CardTitle>
          <CardAction className="ml-auto self-center">
            <Button variant="outline" size="sm" onClick={this.onSaveSettings}>
              Save Settings
            </Button>
          </CardAction>
        </CardHeader>
        <CardContent className="grid gap-4">
          <Label className="cursor-pointer justify-self-start">
            <Checkbox checked={this.state.enabled} onCheckedChange={this.onEnabledToggle} />
            Meetings enabled
          </Label>
          <div className="flex items-center gap-2">
            <Label>Minimum notice:</Label>
            <Select value={`${this.state.minimum_notice_hours}`} onValueChange={this.onNoticeHoursChange}>
              <SelectTrigger size="sm" className="w-auto">
                <SelectValue/>
              </SelectTrigger>
              <SelectContent>
                {NOTICE_HOURS_OPTIONS.map(opt => (
                  <SelectItem key={opt.value} value={`${opt.value}`}>{opt.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <hr className="border-border"/>
          <WeeklyTimeslots
            times={times}
            onSaveTimes={this.onSaveTimes}
          />
        </CardContent>
      </Card>
    )
  }
}

export default MeetingAvailability
